import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';
import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';

const PREFIX = '[commercialEmailQuery]';

export const queryCommercialEmail = async (commercialId: number) => {
  console.log(PREFIX, `Fetching commercial #${commercialId}...`);
  const response = await COMMERCIAL_ENDPOINTS.getOneEmail(commercialId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commercial #${commercialId}.`);
  return json as Pick<Commercial, 'email'>;
};
